export default __webpack_public_path__ + "static/media/location.45e940d6.svg";